import type { ReactNode } from "react";

interface ComparisonPageTemplateProps {
  children: ReactNode;
}

export const ComparisonPageTemplate = ({ children }: ComparisonPageTemplateProps) => (
  <div className="comparison-page-template" data-comparison-template="standard">
    {children}
  </div>
);
